import React from 'react';
import * as SiIcons from 'react-icons/si';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import APAlfredLogo from './APAlfredLogo';

const { SiTiktok } = SiIcons;

function Footer() {
  return (
    <motion.div 
      className="flex flex-col md:flex-row justify-center items-center gap-4 pt-8 mt-8 border-t border-gray-200 dark:border-gray-700 pb-8"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="flex flex-col sm:flex-row items-center gap-2 text-center sm:text-left">
        <div className="flex items-center">
          <motion.div 
            whileHover={{ rotate: [0, -10, 10, 0], transition: { duration: 0.5 } }}
            className="mr-2"
          >
            <APAlfredLogo size={24} />
          </motion.div>
          
          <div className="flex items-center font-['Poppins'] text-sm sm:text-base">
            <span className="font-extrabold text-[#2B5596]">APA</span>
            <span className="font-extrabold text-[#F54CC8]">lfred</span>
            <span className="mx-2 text-gray-400">|</span>
            <span className="text-gray-600 dark:text-gray-400 mr-1">Una aplicación de</span>
            <a 
              href="https://appfred.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="font-extrabold bg-gradient-to-r from-blue-600 to-cyan-500 bg-clip-text text-transparent hover:opacity-80 transition-opacity"
            >
              Appfred
            </a>
          </div>
        </div>

        <div className="text-sm text-gray-600 dark:text-gray-400 sm:ml-1">
          © 2026, Alfredo Menéndez
        </div>
      </div>

      <motion.a 
        href="https://www.tiktok.com/@alfredmenendez" 
        target="_blank" 
        rel="noopener noreferrer"
        className="text-gray-800 hover:text-[#F54CC8] transition-colors dark:text-gray-400 dark:hover:text-[#F54CC8]"
        whileHover={{ scale: 1.2, rotate: [0, -10, 10, 0] }}
        transition={{ duration: 0.3 }}
      >
        <SafeIcon icon={SiTiktok} className="w-6 h-6" />
      </motion.a>
    </motion.div>
  );
}

export default Footer;